/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */
import FormikYourCoverForm from './YourCoverForm';

export default FormikYourCoverForm;
